import { useState } from 'react'
import Popup from 'src/Components/Popup'
import style from './style.module.scss'
import { IClientCreate } from 'src/utils/Interfaces/client.interface'
import TextArea from 'src/Components/Form/TextArea'

interface Props {
  handleClientAssets: ({ assets }: { assets: string }) => void
  setClientAssetsPopup: (value: boolean) => void
  defaultData: IClientCreate
}
export const ClientAssetsPopup = ({ handleClientAssets, setClientAssetsPopup, defaultData }: Props) => {
  const [assets, setAssets] = useState(defaultData?.assets || '')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!assets) return
    handleClientAssets({
      assets
    })
  }

  return (
    <Popup className={style.new_experiment} title="Edit client's assets" closePopup={() => setClientAssetsPopup(false)}>
      <form onSubmit={handleSubmit}>
        <TextArea name="assets" label="Assets" value={assets} onChange={(e) => setAssets(e.target.value)} />
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
